export default __webpack_public_path__ + "static/media/qbyHGQcOhx.087a07a5.png";